import { render } from "./cardAdd.vue?vue&type=template&id=4686b8ae&scoped=true"
import script from "./cardAdd.vue?vue&type=script&lang=js"
export * from "./cardAdd.vue?vue&type=script&lang=js"

import "./cardAdd.vue?vue&type=style&index=0&id=4686b8ae&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4686b8ae"]])

export default __exports__